const host = typeof window !== "undefined" ? window.location.hostname : "localhost";
const protocol = typeof window !== "undefined" ? window.location.protocol : "http:";
const isLocal = host === "localhost" || host === "127.0.0.1";
const defaultProdApi = "https://javastreams.onrender.com/api";
export const API_BASE_URL = isLocal ? `${protocol}//${host}:8081/api` : defaultProdApi;
